import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  signIn (params) {
    const unifiedParams = `${params.email}:${params.password}`

    const headers = {
      authorization: `Basic ${btoa(unifiedParams)}`,
      recaptcha: params.reCaptchaToken
    }

    delete params.reCaptchaToken

    return custAxios(headers).get(Const.API_AUTH, params)
  },
  signUp (params) {
    const headers = {
      recaptcha: params.reCaptchaToken
    }

    delete params.reCaptchaToken

    return custAxios(headers).post(Const.API_AUTH_USER, params)
  },
  userLogout (refreshToken) {
    const headers = {
      'x-refresh-token': refreshToken
    }

    return custAxios(headers).get(`${Const.API_AUTH_USER}/logout`)
  },
  getPlanTypes () {
    return custAxios().get(`${Const.SERVICE_API_PLANTYPE}`)
  },
  getUserData (idUser) {
    return custAxios().get(`${Const.API_USER_DATA}/Detail/${idUser}`)
  },
  getClientCredit (idClient) {
    return custAxios().get(`${Const.API_CLIENT_CREDIT}/credit/${idClient}`)
  },
  editUserData (user) {
    return custAxios().put(`${Const.API_USER_DATA}/${user.idUserLogged}`, user)
  },
  editPatchUserData (user) {
    return custAxios().patch(`${Const.API_USER_DATA}/${user.idUserLogged}`, { password: user.password, currentPassword: user.currentPassword })
  },
  verifyToken (params) {
    return custAxios().get(`${Const.API_AUTH_USER}/verify-token`, params)
  },
  renewToken (headers) {
    const customHeaders = {
      ...headers,
      'x-refresh-token': window.localStorage.getItem('refresh_token')
    }

    return custAxios(customHeaders).get(`${Const.API_AUTH_USER}/renew-token`)
  },
  recoverPassword (params) {
    const headers = {
      recaptcha: params.reCaptchaToken
    }

    delete params.reCaptchaToken

    return custAxios(headers).post(`${Const.API_RECOVER_ACCOUNT}/forget-password`, params)
  },
  updatePassword (params) {
    const headers = {
      recaptcha: params.reCaptchaToken
    }

    const updatedParams = {
      password: params.password
    }

    delete params.reCaptchaToken

    return custAxios(headers).post(`${Const.API_RECOVER_ACCOUNT}/update-password?token=${params.token}`, updatedParams)
  },
  getCreditInfo (idClient) {
    return custAxios().get(`${Const.CREDIT_INFO}/${idClient}`)
  }
}
